export const isRenderFailure = '_isRenderFailure';
